// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__SkadA","loadingBox":"Loading_loadingBox__29UPg","hide":"Loading_hide__2FY3E"};